// extracted by mini-css-extract-plugin
module.exports = {"layout":"index_layout__mOh3L","container":"index_container__xMf_s","main":"index_main__v7S_B","aside":"index_aside__nFrUG","h1":"index_h1__96BXl","tab":"index_tab__dulVT"};